<div class="gbr-simple-input-wrapper">
  <coin-v2-card
    styleVariant="large"
    padding="none"
    [class.invalid]="showError">
    <div class="empty">
      @if (display) {
        <div
          class="selected"
          animate.enter="fly-in-from-bottom">
          <div>
            <p class="label">
              {{ label | translate }}
              @if (isRequired) {
                *
              }
            </p>
            <div>
              @switch (type) {
                @case (types.DateRange) {
                  <p
                    class="value"
                    [innerHTML]="getDateRangeText(value)"></p>
                }
                @case (types.YesNo) {
                  <p class="value">
                    {{ (value ? 'general.yes' : 'general.no') | translate }}
                  </p>
                }
                @default {
                  <p class="value">
                    {{ value }}
                  </p>
                }
              }
            </div>
          </div>
          @if (type === types.DateRange) {
            <div>
              <p class="label">
                {{ 'gbr.simple-input.range' | translate }}
                @if (isRequired) {
                  *
                }
              </p>
              <p class="value">{{ getRangeValue(value) }} {{ 'gbr.simple-input.weeks' | translate }}</p>
            </div>
          }
          @if (type === types.DateRange) {
            <div>
              <div class="coin-chip-info organization">
                <p class="title">{{ 'gbr.simple-input.grant' | translate }}:</p>
                <p class="value">{{ getGrantValue(value) }} {{ 'gbr.simple-input.days' | translate }}</p>
              </div>
            </div>
          }
        </div>
      } @else {
        <p class="text">
          {{ label | translate }}
          @if (isRequired) {
            *
          }
        </p>
        @if (labelTooltip) {
          <mat-icon
            class="icon-info-gbr"
            [matTooltip]="labelTooltip">
            info_outline
          </mat-icon>
        }
      }

      <div style="flex: 1"></div>
    </div>

    @if (!display) {
      <div
        class="edit"
        [class.yes-no-input]="type === types.YesNo">
        @if (type === types.Text) {
          <coin-v2-text-input
            [placeholder]="'gbr.entry' | translate"
            [disabled]="disabled"
            [(ngModel)]="value"
            (ngModelChange)="userChanges()" />
        }

        @if (type === types.Dropdown) {
          <coin-v2-dropdown
            required
            matFormFieldClass="shadow"
            [disabled]="disabled"
            [(ngModel)]="value"
            (ngModelChange)="userChanges()">
            @for (option of options | sortAlphabetically; track option) {
              <ng-template [coinValue]="option">{{ option }}</ng-template>
            }
          </coin-v2-dropdown>
        }

        @if (type === types.DateRange) {
          <mat-form-field
            class="coin-form-field-outline coin-form-field-outline--shadow coin-form-field-outline--date-range"
            appearance="outline"
            floatLabel="always"
            (click)="picker.open()">
            <mat-date-range-input
              [rangePicker]="picker"
              [min]="minDate"
              [max]="maxDate">
              <input
                matStartDate
                readonly
                [placeholder]="'gbr.vacation.period-start' | translate"
                [disabled]="disabled"
                [(ngModel)]="value.start"
                (dateChange)="manualChange()" />
              <input
                matEndDate
                readonly
                [placeholder]="'gbr.vacation.period-end' | translate"
                [disabled]="disabled"
                [(ngModel)]="value.end"
                (dateChange)="manualChange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        }

        @if (type === types.YesNo) {
          <div class="yes-no-option">
            <div class="yes">
              <coin-v2-checkbox
                [ngModel]="value"
                [label]="'general.yes' | translate"
                [disabled]="disabled"
                (ngModelChange)="toggleYesNo(true)"></coin-v2-checkbox>
            </div>
            <div class="no">
              <coin-v2-checkbox
                [label]="'general.no' | translate"
                [ngModel]="!value"
                [disabled]="disabled"
                (ngModelChange)="toggleYesNo(false)"></coin-v2-checkbox>
            </div>
          </div>
        }
      </div>
    }
  </coin-v2-card>
</div>
